import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 1V23H1V1H23ZM9 7V5H7V7H5V9H7V11H9V9H11V7H9ZM19 7H13V9H19V7ZM8 14.5858L6.58594 13.1717L5.17172 14.5859L6.58579 16L5.17142 17.4144L6.58563 18.8286L8 17.4142L9.41436 18.8286L10.8286 17.4144L9.41421 16L10.8283 14.5859L9.41406 13.1717L8 14.5858ZM19 13.5H13V15.5H19V13.5ZM19 16.5H13V18.5H19V16.5Z"}}]};

const Calculation1Filled = Vue.extend<IconProps>({
  name: 'Calculation1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'calculation-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Calculation1Filled;
